import { PROVIDER_ID } from '../constants'
import type { WalletProvider } from '../../types/wallet'

export const MYALGO_WALLET: WalletProvider = {
  id: PROVIDER_ID.MYALGO_WALLET,
  name: 'MyAlgo Wallet',
  icon: 'iconMyAlgo' // string referenced src/components/SvgImg/defs.tsx
}
